// extracted by mini-css-extract-plugin
export default {"user":"styles_user__GOWH0","edit":"styles_edit__ET1Rw","delete":"styles_delete__k3U0U","table_container":"styles_table_container__AfC6E","userImage":"styles_userImage__rG5Ia"};